import React from "react"
import { Switch, Route, Redirect } from 'react-router-dom';

import { routes, defaultRoute, notFoundRoute } from './appRoutes';

function Routes(props) {
  return (
    <React.Fragment>
      <Switch>
        {routes.map(r => (
          <Route
            key={r.address}
            exact={r.exact}
            path={r.address}
            component={r.component}
          />
        ))}
        <Route exact path={notFoundRoute.address} component={notFoundRoute.component} />
        <Route exact path="/">
          <Redirect to={defaultRoute}></Redirect>
        </Route>
        <Route path="*">
          <Redirect to={notFoundRoute.address} />
        </Route>
      </Switch>
    </React.Fragment>
  )
}

export default Routes